// extracted by mini-css-extract-plugin
module.exports = {"Start":"Start_Start__3AI-A","StartButtonHeader":"Start_StartButtonHeader__338uP","StartButton":"Start_StartButton__w-K62"};